import { useEffect, useCallback, useState } from 'react';
import { usePathname, useRouter } from 'src/routes/hooks';
import { paths } from 'src/routes/paths';

import { useAuthContext } from '../hooks';

type Props = {
  children: React.ReactNode;
};

export default function AuthGuard({ children }: Props) {
  const router = useRouter();
  const pathName = usePathname();

  const { authenticated, user, loading } = useAuthContext();
  const [checked, setChecked] = useState(false);

  const check = useCallback(() => {
    if (!authenticated && !loading) {
      // Capture the full URL including query parameters
      const returnToParam = encodeURIComponent(window.location.href);

      // Get the base redirect URL
      const baseUrl = !user?.firstname && authenticated ? paths.auth.profile : paths.auth.login;

      // Check if the baseUrl already contains query parameters
      const hasQueryParams = baseUrl.includes('?');

      // Build the final URL
      // If baseUrl already has query params, use & to add another param, otherwise use ?
      const href = `${baseUrl + (hasQueryParams ? '&' : '?')}returnTo=${returnToParam}`;

      console.log('Redirecting to:', href);
      router.replace(href);
    } else {
      setChecked(true);
    }
  }, [authenticated, router, user?.firstname, loading]);

  useEffect(() => {
    check();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!checked) {
    return null;
  }

  return <>{children}</>;
}
